
import cisLayout from './layout/index.js'
import cisCharts from './charts/index.js'
import cisTip from './cisTip.vue'
const cisView = {
  cisHeader: cisLayout.Header,
  cisContent: cisLayout.Content,
  cisFooter: cisLayout.Footer,
  cisSider: cisLayout.Sider,
  ...cisCharts,
  cisTip
}

export default {
  install(Vue, opts = {}) {
    Object.keys(cisView).forEach(key => {
      Vue.component(key, cisView[key])
    })
    // 注册维权工单组件到this上
    // Vue.prototype.$Order = cisOrder
  }
}
